import axios from "axios";
import Links from "@/shared/constants/Links";

const base = Links.defenseHodAssignments.base;

const AffiliationDefenseHodAssignments = {
  getForLecturer: async (lecturerId) => axios.get(`${base}/lecturers/${lecturerId}`),

  assign: async (lecturerId, departmentIds) => axios.put(
    `${base}/lecturers/${lecturerId}`,
    { departmentIds },
  ),

  remove: async (lecturerId) => axios.delete(`${base}/lecturers/${lecturerId}`),
};

export default AffiliationDefenseHodAssignments;
